import { useGlobalState } from '@/hooks';
import { ISSUE_CONFIG, TRACKING_MILESTONE_TRANSLATION } from '@/modules/pmt/constants';
import type { IProgressTracker } from '@/modules/pmt/interfaces';
import Image from 'next/image';
import {
  BigCircle,
  ProgressItem,
  ProgressTitle,
  SmallCircle,
  TrackerDashedLine,
  TrackerFullLine,
  TrackerWrapper,
} from './ProgressTracker.styles';

export const ProgressTracker: React.FC<IProgressTracker> = ({ hasIssue, milestone, stageList }) => {
  const { t } = useGlobalState();
  const translatedMilestone = t(TRACKING_MILESTONE_TRANSLATION[milestone]);

  return (
    <TrackerWrapper milestone={milestone} hasIssue={hasIssue} stageList={stageList}>
      <TrackerDashedLine />
      <TrackerFullLine />
      {stageList.map((stage, index) => {
        const stageIcon = hasIssue ? ISSUE_CONFIG.iconSrc : stage.iconSrc;
        const stageAlt = hasIssue ? 'Issue icon' : translatedMilestone;
        return (
          <ProgressItem key={index}>
            <div>
              {!stage.milestones.has(milestone) ? (
                <SmallCircle />
              ) : (
                <BigCircle>
                  <Image src={stageIcon} alt={stageAlt} priority width={20} height={20} />
                </BigCircle>
              )}
              {stage.milestones.has(milestone) && <ProgressTitle>{translatedMilestone}</ProgressTitle>}
            </div>
          </ProgressItem>
        );
      })}
    </TrackerWrapper>
  );
};
